import "./lookup.js";
import "./details.js";



// WEBPACK FOOTER //
// ./src/pages/releaseOrders/index.js